import { render, staticRenderFns } from "./ProductACVTextsAddLangDialog.vue?vue&type=template&id=165896ba&scoped=true&"
import script from "./ProductACVTextsAddLangDialog.vue?vue&type=script&lang=js&"
export * from "./ProductACVTextsAddLangDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "165896ba",
  null
  
)

export default component.exports